import { Controller } from "@hotwired/stimulus";
import debounce from "lodash.debounce";

export default class extends Controller {
  static values = { debounce: 200, updateUrl: Boolean };

  initialize() {
    if (this.debounceValue > 0) {
      this.debouncedSubmit = debounce(this.submit, this.debounceValue);
    } else {
      this.debouncedSubmit = this.submit;
    }

    addEventListener("turbo:submit-end", this.handleSubmitEnd);
  }

  submit() {
    this.element.requestSubmit();
  }

  search() {
    this.debouncedSubmit();
  }

  handleSubmitEnd(event) {
    const queryString = event.detail.formSubmission.location.search;
    window.history.pushState("", "", queryString);
  }
}
